module.exports = __webpack_public_path__ + "static/media/icon-close.d04ffb7c.svg";